import { render, staticRenderFns } from "./workpackage-pg-item.vue?vue&type=template&id=6ecb2b94&scoped=true"
import script from "./workpackage-pg-item.vue?vue&type=script&lang=js"
export * from "./workpackage-pg-item.vue?vue&type=script&lang=js"
import style0 from "./workpackage-pg-item.vue?vue&type=style&index=0&id=6ecb2b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb2b94",
  null
  
)

export default component.exports